import React, { useEffect, useState } from "react";
import {
  CREATE_ADDRESS,
  CREATE_FAMILY,
  GET_FAMILY_BY_REFF,
  UPDATE_ADDRESS,
  UPDATE_CANDIDATE,
  UPDATE_FAMILY,
} from "../../API";
import LoadingBtn from "../../../../Widgets/LoadingBtn";
import { AlertNotif } from "../../../../../Library/AlertNotif";
import { Error404 } from "../../../../../Library/LoaderPage";
import { Card } from "react-bootstrap";
import { SelectInputProfession } from "../../_core/SelectInput";
import {
  handleKeyDown,
  validateCellular,
  validateName,
} from "../../_core/_core";
import {
  CapitalizeEachWord,
  EncodeURIComponentSafe,
  RemoveEmptyValue,
  splitFullName,
} from "../../../../../Library/GlobalHelper";
import { openModal } from "../../../../../Library/ModalPopUp";
import { MessageError, MessageSuccess } from "../ProfileUI";

export default function CardParents({ student, ReloadDataStd, enrollment }) {
  const parents = [
    {
      id: 1,
      type: "MOTHER",
      gender: "w",
      reff_family_id: student?.reff_family_id,
      fullname: "",
      firstname: "",
      lastname: "",
      middlename: "",
      profession: "",
      cellular: "",
      address: "",
    },
    {
      id: 2,
      type: "FATHER",
      gender: "p",
      reff_family_id: student?.reff_family_id,
      fullname: "",
      firstname: "",
      lastname: "",
      middlename: "",
      profession: "",
      cellular: "",
      address: "",
    },
  ];
  const [families, setFamilies] = useState({
    loading: false,
    data: parents,
    message: "",
  });
  const ReloadData = async () => {
    setFamilies({ loading: true, data: [], message: "" });
    const results = await GET_FAMILY_BY_REFF({
      reffid: student.reff_family_id,
    });
    if (results.data && Object.values(results.data).length > 0) {
      const spliting_name = results.data.map((v) => {
        const { firstname, middlename, lastname } = splitFullName(v.fullname);
        return {
          ...v,
          firstname,
          middlename,
          lastname,
        };
      });
      const combined = parents.map((parent) => {
        const matchingData = spliting_name.find(
          (item) => item.type === parent.type
        );
        return matchingData ? { ...parent, ...matchingData } : parent;
      });

      const fams_map_addr = combined
        ? combined.map((item) => {
          const addr = item.address;
          const t_addr = addr && Object.values(addr).length || 0;
          const last_addr = t_addr > 0 ?  addr[t_addr - 1] : "";
          if (last_addr && Object.values(last_addr).length > 0) {
            item.cellular = last_addr?.cellular1 || "";
            item.email = last_addr?.email || "";
            item.addr_id = last_addr?.id || 0;
            item.address = last_addr?.address || "";
          }
          return item;
        })
        : combined;
      setFamilies({ loading: false, data: fams_map_addr, message: "" });
    } else {
      setFamilies(results);
    }
  };
  useEffect(() => {
    if (student.reff_family_id) {
      ReloadData();
    }
  }, [student.reff_family_id]);
  return (
    <div id="parents-form">
      {families.loading ? (
        <LoadingBtn />
      ) : families.message ? (
        <AlertNotif message={families.message} color="danger" />
      ) : Object.values(families.data).length > 0 ? (
        <div className="row">
          {families.data.map((v, index) => (
            <div className="col-6" key={index}>
              <FormFamily data={v} ReloadData={ReloadData} ReloadDataStd={ReloadDataStd} enrollment={enrollment} />
            </div>
          ))}
        </div>
      ) : (
        <Error404 />
      )}
    </div>
  );
}

const FormFamily = ({ data, ReloadData, ReloadDataStd, enrollment }) => {
  const has_enrollment = Object.values(enrollment).length > 0 ? true : false;
  const disabled_field = data.reff_family_id ? false : true;
  const [errors, setErrors] = useState({});
  const gender = data.type === "MOTHER" ? "w" : "p";
  const [profession_oth, setProfessionOth] = useState(
    data?.profession_other || ""
  );
  const [profession, setProfession] = useState(data?.profession?.id || "");
  const [firstname, setFirstname] = useState(data?.firstname || "");
  const [lastname, setLastname] = useState(data?.lastname || "");
  const [middlename, setMiddlename] = useState(data?.middlename || "");
  const [cellular, setCellular] = useState(data?.cellular || "");
  const [email, setEmail] = useState(data?.email || "");

  const validateForm = () => {
    const newErrors = {};
    const firstnameError = validateName(firstname);
    if (firstnameError) newErrors.firstname = firstnameError;
    const cellularError = validateCellular(cellular);
    if (cellularError) newErrors.cellular = cellularError;
    if (!email) newErrors.email = "This field is required";
    if (!profession) newErrors.profession = "This field is required";

    setErrors(newErrors);

    const errorCount = Object.keys(newErrors).length;
    return errorCount === 0;
  };

  useEffect(() => {
    validateForm();
  }, [firstname, cellular, email, profession]);

  const [submit, setSubmit] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setSubmit({ loading: true, message: "", data: [] });
      const param = {
        reff_id: EncodeURIComponentSafe(data.reff_family_id),
        firstname: EncodeURIComponentSafe(firstname),
        middlename: middlename ? EncodeURIComponentSafe(middlename) : "",
        lastname: lastname ? EncodeURIComponentSafe(lastname) : "",
        profession_id: profession,
        type: data?.type,
        gender: gender,
        cellular,
        email,
      };
      if (profession_oth) {
        param.profession_other = EncodeURIComponentSafe(profession_oth);
      }

      if (data.id !== 1 && data.id !== 2) {
        let is_finish = false;
        if (has_enrollment) {
          const param_enrollment = {
            id: enrollment?.regstudent?.id,
            parent_name: EncodeURIComponentSafe(`${firstname} ${middlename} ${lastname}`),
            parent_phone: cellular,
            parent_email: EncodeURIComponentSafe(email),
            fm_type: param.type
          }
          try {
            const update_data = await UPDATE_CANDIDATE(param_enrollment);
            console.log(update_data);
          } catch (error) {
            console.log(error);
          }
          is_finish = true;
        } else {
          is_finish = true;
        }

        if (is_finish) {
          param.id = data.id;
          const param_fams = RemoveEmptyValue(param);
          const param_addr = {
            id: data.addr_id,
            cellular1: cellular,
            email,
          };
          const [r_fams, r_addr] = await Promise.all([
            UPDATE_FAMILY(param_fams),
            UPDATE_ADDRESS(param_addr),
          ]);
          if (
            r_fams.data &&
            Object.values(r_fams.data).length > 0 &&
            r_addr.data &&
            Object.values(r_addr.data).length > 0
          ) {
            openModal({
              message: <MessageSuccess message={"Successfully saved"} />,
            });
            ReloadData();
           ReloadDataStd();
          } else {
            openModal({
              message: (
                <MessageError
                  message={r_fams.message || r_addr.message}
                  title="Failed Save"
                />
              ),
            });
          }
          setSubmit(r_fams);
        } else {
          setSubmit({ loading: false, message: "No data post founded", data: [] });
          openModal({
            message: (
              <MessageError
                message={
                  "No data post founded."
                }
              />
            ),
          });
        }
      } else {
        const results = await CREATE_FAMILY(param);
        if (results.data && Object.values(results.data).length > 0) {
          const reff_address = results.data?.reff_address || "";
          const param_addr = {
            reff_id: EncodeURIComponentSafe(reff_address),
            cellular1: cellular,
            email,
          };
          const r_insert_addt = await CREATE_ADDRESS(param_addr);
          if (r_insert_addt.data && Object.values(r_insert_addt.data).length > 0) {
            openModal({
              message: (<MessageSuccess message={"Successfully saved"} />)
            });
            ReloadData();
          } else {
            openModal({
              message: (
                <MessageError
                  message={r_insert_addt.message}
                  title="Failed Save"
                />
              ),
            });
          }
        } else {
          openModal({
            message: (
              <MessageError message={results.message} title="Failed Save" />
            ),
          });
        }

        setSubmit(results);
      }
    } else {
      openModal({
        message: (
          <MessageError
            message={
              "Please verify your input and ensure it is completed correctly."
            }
          />
        ),
      });
      setSubmit({ loading: false, message: "", data: [] });
    }
  };

  return (
    <Card className="w-100">
      <Card.Body>
        {!data.reff_family_id && (
          <AlertNotif
            message={
              "Unable to update the data because the reference ID (reff_id) is not associated with this student."
            }
            color="info"
          />
        )}
        <form
          autoComplete="off"
          method="post"
          onSubmit={(e) => handleSubmit(e)}
        >
          <div className="form-control form-control-lg form-control-solid font-weight-bold text-center mb-5">
            {data?.type}
          </div>
          <div className="form-group mb-0">
            <label className="font-weight-bold">Full Name</label>
          </div>
          <div className="row">
            <div className="col-4">
              <div className="form-group">
                <label className="font-weight-bold">
                  Firstname
                  <sup className="text-danger">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm form-control-solid font-weight-bold"
                  value={firstname}
                  onChange={(e) =>
                    setFirstname(CapitalizeEachWord(e.target.value))
                  }
                  disabled={disabled_field}
                />
                {errors.firstname && (
                  <div className="text-danger">{errors.firstname}</div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label className="font-weight-bold">Middlename</label>
                <input
                  type="text"
                  className="form-control form-control-sm form-control-solid font-weight-bold"
                  value={middlename}
                  onChange={(e) =>
                    setMiddlename(CapitalizeEachWord(e.target.value))
                  }
                  disabled={disabled_field}
                />
                {errors.middlename && (
                  <div className="text-danger">{errors.middlename}</div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="form-group">
                <label className="font-weight-bold">Lastname</label>
                <input
                  type="text"
                  className="form-control form-control-sm form-control-solid font-weight-bold"
                  value={lastname}
                  onChange={(e) =>
                    setLastname(CapitalizeEachWord(e.target.value))
                  }
                  disabled={disabled_field}
                />
                {errors.lastname && (
                  <div className="text-danger">{errors.lastname}</div>
                )}
              </div>
            </div>
          </div>
          <div className="form-group mb-3">
            <label className="font-weight-bold">
              Profession
              <sup className="text-danger">*</sup>
            </label>
            <SelectInputProfession
              data={profession}
              setData={setProfession}
              data_oth={profession_oth}
              setOth={setProfessionOth}
              disabled={disabled_field}
              isSolid={true}
            />
            {errors.profession && (
              <div className="text-danger">{errors.profession}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="font-weight-bold">
              Cellular Number
              <sup className="text-danger">*</sup>
            </label>
            <input
              type="text"
              name="cellular"
              disabled={disabled_field}
              className="form-control form-control-sm form-control-solid mb-3 mb-lg-0"
              onKeyDown={handleKeyDown}
              onInput={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setCellular(value);
              }}
              value={cellular}
            />
            {errors.cellular && (
              <div className="text-danger">{errors.cellular}</div>
            )}
          </div>
          <div className="form-group mb-3">
            <label className="font-weight-bold">
              Email
              <sup className="text-danger">*</sup>
            </label>
            <input
              type="text"
              className="form-control form-control-sm form-control-solid"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={disabled_field}
            />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>

          <div className="text-center">
            <button
              className="btn btn-lg btn-block btn-primary"
              type="submit"
              disabled={submit.loading}
            >
              {submit.loading ? "Processing..." : "Save Changes"}
            </button>
          </div>
        </form>
      </Card.Body>
    </Card>
  );
};
